import React from 'react';
import classnames from 'classnames';
import 'src/components/Pagination/Pagination.scss';
import { Link } from 'react-router';

type Props = {
    currentPage: number;
    createUrl(any);
    refine?(val: number);
};

export const PrevLink: React.FC<Props> = (props) => {
    const { currentPage, createUrl, refine } = props;
    return (
        <li
            className={classnames({
                ['ais-Pagination-item']: true,
                ['ais-Pagination-item--previousPage']: true,
                ['ais-Pagination-item--disabled']: currentPage === 1,
            })}
        >
            {currentPage === 1 && <span className="ais-Pagination-link">Previous</span>}
            {currentPage > 1 && (
                <Link
                    className="ais-Pagination-link"
                    to={createUrl(currentPage - 1)}
                    onClick={(event) => {
                        if (!refine) return;
                        event.preventDefault();
                        refine(currentPage - 1);
                    }}
                >
                    Previous
                </Link>
            )}
        </li>
    );
};
